import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Button, Form, Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CustomerOrdersStore } from "../../../stores/CustomerOrdersStore";
import { STORE_CUSTOMER_ORDERS, SOURCES_AB61, SOURCES_ABTEKA, SOURCES_AS61, STORE_AUTH, STORE_CUSTOMERS } from "../../../constants";
import { RouteComponentProps, Link } from "react-router-dom";
import { formatDate, formatMoney } from "../../../common/Formatting";
import { LinkContainer } from "react-router-bootstrap";
import { TableFooterPager } from "../../../common/UI/TableFooterPager";
import { wrapInput, wrapCheckbox } from "../../../common/FormChangeWrapper";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { MultiSelect } from "../../../common/UI/MultiSelect";
import { AuthStore, CustomersStore, Customer } from "../../../stores";
import { SelectCustomerModal } from "../../../components/SelectCustomerModal";
import { NotificationLevel } from "../../../stores/NotificationStore";
registerLocale('ru', ru)

interface IProps {
    history: any,
    [STORE_CUSTOMER_ORDERS]: CustomerOrdersStore
    [STORE_CUSTOMERS]: CustomersStore
}

interface IState {
    currentPage: number,
    filterFormIsOpened: boolean,
    filteredManagerIds: string[],
    filteredCustomerId: string,
    searchText: string,
    dateFrom?: Date,
    dateTo?: Date,
    source?: string,
    selectCustomerModalIsOpened: boolean,
    selectedCustomerId?: string,
    selectedCustomerName?: string,
    onlyUnAccepted: boolean,
    showHidden: boolean
}


type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_CUSTOMER_ORDERS, STORE_CUSTOMERS, STORE_AUTH)
@observer
export class CustomerOrdersPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page,
            filterFormIsOpened: false,
            searchText: "",
            filteredManagerIds: [],
            filteredCustomerId: "-1",
            source: "",
            onlyUnAccepted: false,
            selectCustomerModalIsOpened: false,
            showHidden: false
        };
    }

    customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;
    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;
    authStore = (this.props as any)[STORE_AUTH] as AuthStore;

    private backUrl = "";


    loadData = () => {
        this.customerOrdersStore.loadOrders(
            this.state.filteredManagerIds,
            this.state.selectedCustomerId || "",
            this.state.currentPage,
            this.state.onlyUnAccepted,
            this.state.showHidden,
            this.state.source,
            this.state.dateFrom,
            this.state.dateTo,
            this.state.searchText);
    }

    componentDidMount() {
        const savedFilter = JSON.parse(localStorage.getItem("ordersFilter") || "{}");
        if (savedFilter.dateFrom != null) {
            savedFilter.dateFrom = new Date(savedFilter.dateFrom);
        }
        if (savedFilter.dateTo != null) {
            savedFilter.dateTo = new Date(savedFilter.dateTo);
        }

        this.setState(Object.assign({}, this.state, savedFilter), () => {
            this.loadData();
            this.customerOrdersStore.loadManagers();
        });

        if (this.authStore.roles.indexOf("Reports") > -1) { 
            const script = document.createElement('script');
            script.src = '/js/parseCustomerOrdersStats.js';
            script.async = true;
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }   

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        const prevPage = parseInt(prevProps.match.params.page) || 1;
        const page = parseInt(this.props.match.params.page) || 1;

        this.backUrl = encodeURIComponent("/sales/customerorders/" + page);

        if (prevPage != page) {
            this.setState({
                currentPage: page
            }, () => {
                this.loadData();
            })
        }
    }

    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            source: "",
            onlyUnAccepted: false,
            showHidden: false,
            searchText: "",
            filteredManagerIds: [],
            filteredCustomerId: "-1",
            dateFrom: undefined,
            dateTo: undefined,
            selectedCustomerId: undefined,
            selectedCustomerName: undefined
        });
        localStorage.removeItem("ordersFilter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            this.saveFilterToLocalStorage();
        });
    }

    private saveFilterToLocalStorage = () => {
        if (this.state.filteredCustomerId == "-1"
            && this.state.filteredManagerIds == null
            && this.state.searchText == ""
            && this.state.source == null
            && this.state.selectedCustomerId == undefined
            && this.state.dateTo == null && this.state.dateFrom == null) {
            localStorage.removeItem("ordersFilter");
            return;
        }
        localStorage.setItem("ordersFilter", JSON.stringify({
            source: this.state.source,
            filteredManagerIds: this.state.filteredManagerIds,
            filteredCustomerId: this.state.filteredCustomerId,
            selectedCustomerId: this.state.selectedCustomerId,
            selectedCustomerName: this.state.selectedCustomerName,
            searchText: this.state.searchText,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            filterFormIsOpened: true,
            onlyUnAccepted: this.state.onlyUnAccepted,
            showHidden: this.state.showHidden
        }));
    }
    private openSelectCustomerModal = () => {
        if (this.state.source == "")
            this.customersStore._rootStore.notificationStore.addNotification("Источник не выбран!", NotificationLevel.error);
        else
            this.setState({ selectCustomerModalIsOpened: true });
    }

    render() {
        return [
            <TablePageHeader header="Заказы покупателей" reload={() => {
                this.props.history.push("/sales/customerorders/1");
                this.loadData();
            }} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.props.history.push("/sales/customerorders/1")
                    this.loadData();
                }}>

                    <Button type="button" size="sm" onClick={() => {
                        this.props.history.push("/sales/newcustomerorder")
                    }}>
                        <FontAwesomeIcon icon="plus" />
                        {' '}
                        Заказ
                    </Button>
                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened} style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                    <Form.Control size="sm"
                        placeholder="Номер или комментарий"
                        style={{ marginLeft: "15px", width: "250px" }}
                        value={this.state.searchText}
                        name="searchText"
                        onChange={wrapInput(this.changeFilter)}
                    />
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={() => {
                                                this.props.history.push("/sales/customerorders/1");
                                                this.loadData();
                                            }}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>

                                            <Form.Group controlId="filterForm.SelectSource">
                                                <Form.Label>Источник</Form.Label>
                                                <Form.Control as="select" size="sm"
                                                    value={this.state.source}
                                                    name="source"
                                                    onChange={wrapInput(this.changeFilter)}>

                                                    <option value="">Все</option>
                                                    <option value={SOURCES_AS61}>As61.ru</option>
                                                    {this.authStore.isCallCentre ? <option value={SOURCES_AB61}>Ab61.ru</option>
                                                        : []}
                                                    <option value={SOURCES_ABTEKA}>Abteka.ru</option>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Check
                                                disabled={this.state.source !== SOURCES_ABTEKA}
                                                type="checkbox"
                                                id="onlyUnAccepted"
                                                checked={this.state.onlyUnAccepted && this.state.source === SOURCES_ABTEKA}
                                                name="onlyUnAccepted"
                                                label="Только неподтвержденные"
                                                onChange={wrapCheckbox((name: string, value: any, checked: boolean) => {
                                                    this.changeFilter(name, checked);
                                                })}
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                id="showHidden"
                                                checked={this.state.showHidden}
                                                name="showHidden"
                                                label="Показать скрытые"
                                                onChange={wrapCheckbox((name: string, value: any, checked: boolean) => {
                                                    this.changeFilter(name, checked);
                                                })}
                                            />
                                        </Col>
                                        {this.authStore.isCallCentre ?
                                            <Col sm="3">
                                                <Form.Group controlId="filterForm.SelectManager">
                                                    <Form.Label>Ответственный</Form.Label>
                                                    <MultiSelect
                                                        precheckedAll={false}
                                                        title="Фильтр по менеджеру"
                                                        data={this.customerOrdersStore.managers}
                                                        selectedItems={this.state.filteredManagerIds}
                                                        onChange={(keys: string[]) => {
                                                            this.changeFilter("filteredManagerIds", keys);
                                                        }}
                                                        width="100%"
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                                <Form.Group controlId="filterForm.SelectClient">
                                                    <Form.Label>Контрагент</Form.Label>
                                                    <div className="form-inline" style={{
                                                        border: "1px solid #d8d8d8",
                                                        borderRadius: "3px",
                                                        padding: "0px 2px",
                                                        fontSize: "11pt",
                                                        cursor: "pointer"
                                                    }}
                                                        onClick={this.openSelectCustomerModal}>
                                                        <div style={{ width: "100%", marginLeft: "-40px", paddingLeft: "40px" }}>
                                                            {this.state.selectedCustomerId == undefined ?
                                                                <span>Не выбрано</span> :
                                                                <span>{this.state.selectedCustomerName}</span>}

                                                        </div>
                                                        {this.state.selectedCustomerId == undefined ? [] :
                                                            <Button type="button" variant="link" size="sm" style={{ marginLeft: "-3px", marginRight: "-12px" }}
                                                                onClick={(e: any) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.setState({
                                                                        selectedCustomerId: undefined,
                                                                        selectedCustomerName: undefined
                                                                    }, () => {
                                                                        this.saveFilterToLocalStorage()
                                                                    });
                                                                }}>
                                                                <FontAwesomeIcon icon="times" style={{ color: "black" }} />
                                                            </Button>
                                                        }
                                                        <Button type="button" variant="link" size="sm" style={{
                                                            marginLeft: this.state.selectedCustomerId == undefined ? "9px" : "0"
                                                        }}>
                                                            <FontAwesomeIcon icon="caret-down" style={{ color: "black" }} />
                                                        </Button>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            : []
                                        }
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row > : [],
            <Row key="2">
                <Col sm={12}>
                    <Table bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">№</th>
                                <th></th>
                                <th className="text-center">Время</th>
                                <th className="text-center">Источник</th>
                                <th className="text-center">Точка выдачи</th>
                                <th className="text-center">Контрагент</th>
                                <th className="text-center">Позиций / Сумма</th>
                                <th className="text-center">Статус</th>
                                <th className="text-center">Менеджер</th>
                                <th>Комментарий</th>
                                <th>Комментарий менеджера</th>
                            </tr>
                        </thead>
                        <TableFooterPager
                            columnsCount={11}
                            page={this.customerOrdersStore.currentPage}
                            totalCount={this.customerOrdersStore.totalOrdersCount}
                            pageSize={40}
                            move={"/sales/customerorders"}
                        />
                        <tbody>
                            {this.customerOrdersStore.orders.map((item, index) => <tr key={index} style={{ backgroundColor: item.isHidden ? "#d0d0d0" : "" }}>
                                <td className="text-center">
                                    <LinkContainer to={`/sales/orderdetails/${item.orderGUID}/${this.backUrl}`}>
                                        <Link to={`/sales/orderdetails/${item.orderGUID}/${this.backUrl}`}>{item.orderNumber}</Link>
                                    </LinkContainer>
                                </td>
                                <td className="text-center">
                                    {item.isConfirmed ? <Badge variant="success" title="Подтвержденный заказ"><FontAwesomeIcon icon="check" /></Badge> :
                                        <Badge variant="warning" title="Неподтвержденный заказ"><FontAwesomeIcon icon="exclamation" /></Badge>}
                                </td>
                                <td className="text-center">{formatDate(item.dateCreate)}</td>
                                <td className="text-center">{item.sourceName}</td>
                                <td className="text-center">
                                    <div className="cut-text" style={{ width: "150px", margin: "0 auto" }} title={item.deliveryPointName}>
                                        {item.deliveryPointName}
                                    </div>
                                </td>
                                <td className="text-center">
                                    {`${item.clientName || "фио не указано"}, тел. ${item.clientPhone}`}
                                </td>
                                <td className="text-center">{item.positionsCount} / {formatMoney(item.orderSum)} руб.</td>
                                <td className="text-center">
                                    {item.inWorkPositionsCount > 0 ? <Badge variant="primary" title="Позиций в работе">{item.inWorkPositionsCount}</Badge> : []}
                                    {item.awaitingPositionsCount > 0 ? <Badge variant="info" title="Позиций в ожидании">{item.awaitingPositionsCount}</Badge> : []}
                                    {item.completedPositionsCount > 0 ? <Badge variant="success" title="Завершенных позиций">{item.completedPositionsCount}</Badge> : []}
                                    {item.rejectedPositionsCount > 0 ? <Badge variant="danger" title="Отказов">{item.rejectedPositionsCount}</Badge> : []}
                                </td>
                                <td className="text-center">{item.managerName}</td>
                                <td>{item.clientComment}</td>
                                <td>{item.managerComment}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row >,
            <SelectCustomerModal
                key="3"
                customersStore={this.customersStore}
                isOpened={this.state.selectCustomerModalIsOpened}
                source={this.state.source || "abteka"}
                onCustomerSelected={(customer: Customer) => {
                    this.setState({
                        selectCustomerModalIsOpened: false,
                        selectedCustomerId: customer.id,
                        selectedCustomerName: customer.friendlyName,
                    }, () => {
                        this.saveFilterToLocalStorage()
                    });
                }}
                openNewCustomerModal={() => { }}
                onHideHandler={() => { this.setState({ selectCustomerModalIsOpened: false }) }}
            />
        ]
    }
}